// =============================================================
// blog.js — entry point for the magazine-style blog post page.
// - Bilingual toggle (EN default / ES via ?lang=es), same
//   localStorage key ("siteLang") and URL convention as the site.
// - Scroll reveal for article blocks.
// =============================================================

const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

const VALID_LANGS = ["en", "es"];

function resolveLang() {
  const params = new URLSearchParams(window.location.search);
  const paramLang = params.get("lang");
  const stored =
    typeof localStorage !== "undefined" ? localStorage.getItem("siteLang") : null;
  const lang = paramLang || stored || "en";
  return VALID_LANGS.includes(lang) ? lang : "en";
}

function applyLang(lang) {
  if (typeof localStorage !== "undefined") {
    localStorage.setItem("siteLang", lang);
  }

  document.documentElement.lang = lang;

  // Full article blocks (EN / ES).
  $$("[data-lang-block]").forEach((el) => {
    el.hidden = el.dataset.langBlock !== lang;
  });

  // Inline bilingual strings (footer, chrome).
  $$("[data-en][data-es]").forEach((el) => {
    const value = el.dataset[lang];
    if (typeof value === "string") el.textContent = value;
  });

  // Bilingual hrefs (WhatsApp messages).
  $$("[data-href-en][data-href-es]").forEach((el) => {
    const href = el.dataset[lang === "es" ? "hrefEs" : "hrefEn"];
    if (href) el.setAttribute("href", href);
  });

  // Title + meta description.
  const body = document.body;
  const title = body.dataset[`title${lang === "es" ? "Es" : "En"}`];
  if (title) document.title = title;

  const desc = body.dataset[`desc${lang === "es" ? "Es" : "En"}`];
  const metaDesc = document.querySelector('meta[name="description"]');
  if (desc && metaDesc) metaDesc.setAttribute("content", desc);

  // Language switch links keep the current path.
  $$(".lang-btn").forEach((link) => {
    const target = link.dataset.lang;
    const url = new URL(window.location.href);
    if (target === "en") url.searchParams.delete("lang");
    else url.searchParams.set("lang", target);
    link.href = url.toString();
    link.classList.toggle("active", target === lang);
  });
}

function bindReveal() {
  const targets = $$(".reveal");
  if (!targets.length) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduced || !("IntersectionObserver" in window)) {
    targets.forEach((el) => el.classList.add("is-in"));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-in");
        io.unobserve(entry.target);
      });
    },
    { threshold: 0, rootMargin: "0px 0px -10% 0px" }
  );

  targets.forEach((el) => io.observe(el));
}

function init() {
  const lang = resolveLang();
  applyLang(lang);
  bindReveal();
}

init();
